import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const DeltaStarStarDelta = () => (
  <QPhototModuleSubtopic
    title="Delta-star and Star-delta"
    videos={[
      "https://www.youtube.com/embed/7np1d5ez1hs",
      "https://www.youtube.com/embed/5_mmZNkn9J0",
      "https://www.youtube.com/embed/EN4QU2OczQI"
    ]}
    takeaways={[
      { text: "Practice as many as possible questions from Star-Delta and Delta-Star." },
      { text: "Expected question in both CAT and FAT." },
      { text: "Practice all types of questions." }
    ]}
    questions={[
      {
        image:"/beee_1.jpeg",
      }, 
      {
        image:"/beee_2.jpeg"
      }, 
      {
        text: "Obtain the equivalent resistance Rab for the circuit shown below using Star-Delta transformation and calculate the current 'I'.",
        image:"/beee_3.jpeg"
      },
      {
        image:"/beee_4.jpeg"
      },
      {
        image:"/beee_5.jpeg"
      }


    ]}
    exampleVideos={[]}
  />
);

export default DeltaStarStarDelta;
